import { defineStore } from 'pinia';
import axios from 'axios';
export const userSettingStore = defineStore('userSettingStore',{
    state: () => ({
        userSettingsInfo: null,
    }),
    actions: {
        getUserSettingsAction(id) {
            return axios.get(id ? `/api/usersetting/${id}` : '/api/usersetting');
        },
        getUserSettings(id) {
            return this.getUserSettingsAction(id).then((resp)=> {
                this.userSettingsInfo = resp.data;
            });
        },
        updateUserSettingAction(type, value) {
            return axios.put(`/api/usersetting?type=${type}&value=${value}`);
        }
    }
});